module.exports = __webpack_public_path__ + "static/sport/bgi-form.4849364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/bgi-form.png
// module id = NbZR
// module chunks = 0